<template lang="html">
	<div class="ad-image">
		<div class="image-box" v-show="show_image">
			<div
				class="image"
				:style="`background: url(${getImageUrl(product.logo) || '/assets/images/apa_img.jpg'}) no-repeat;`"
			></div>
		</div>
		<div class="p-desc-box clearfix">
			<div class="clearfix">
				<div class="name-box f-l">
					<div class="insurance">{{ product.product_name }}</div>

					<div class="categories clearfix">
						<div class="category f-l">
							<div class="name f-l">
								{{ product.description }}
							</div>
						</div>
					</div>
				</div>
				<img
					v-if="product.underwriter[0] && product.underwriter[0].logo"
					:src="
						getImageUrl(product.underwriter[0].logo) ||
						'/img/logos/madison.png'
					"
					:alt="product.underwriter[0].name"
					class="logo f-r"
					:title="product.underwriter[0].name"
				/>
				<img
					v-else
					:src="'/img/logos/madison.png'"
					alt="Madison Insurance"
					class="logo f-r"
				/>
			</div>
			<div class="price-box">
				<div class="txt">Starting From:</div>
				<div class="price tx-blue">
					<span class="currency">{{
						product.currency || 'KES'
					}}</span>
					{{ utils.numberWithCommas(product.minimum_premium)
					}}<span class="point">.00</span>
				</div>
				<div class="duration">{{ product.policy_term }}</div>
			</div>
			<div class="act-box clearfix">
				<div class="f-l show-more">Show More</div>
				<!-- <div class="btn btn-ico f-r" @click="showRequirements(product)"><i class="fa fa-shopping-cart"></i></div> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		product: {
			default: function () {
				return {
					icon: '/img/logos/madison.png',
					name: 'Madison Insurance',
					sub_class_code: 'General',
					currency: '$',
					new_price: 590,
					underwriter: [
						{
							logo: '/img/logos/madison.png',
							name: 'Madison Insurance',
						},
					],
					policy_term: 'Yearly',
					logo: '/assets/images/apa_img.jpg',
				};
			},
		},
		show_image: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			utils,
			api,
		};
	},
	methods: {
		getImageUrl(route) {
			if (route) {
				if (route.startsWith('/')) {
					return `${api.getDomain()}${route}`;
				} else {
					return `${api.getDomain()}/${route}`;
				}
			} else {
				return undefined;
			}
		},
		showRequirements(product) {
			Event.$emit('requirements:show', {
				subClass: product.sub_class_code,
			});
		},
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.ad-image {
	box-shadow: 0 2px 6px 0 rgba(69, 73, 91, 0.08);
	height: 100%;
	background: var(--white);

	.act-box {
		.btn-ico {
			background: #f4f5fa;
			padding: 7px 15px;
			color: rgba(0, 31, 95, 0.6);
		}
		.btn-ico:hover {
			color: var(--text-color);
		}
		.show-more {
			cursor: pointer;
			font-size: 13px;
			font-weight: 600;
			margin: 12px 0;
		}
		.show-more:hover {
			color: var(--ne-red);
		}
	}
	.logo {
		width: auto;
		height: auto;
		max-width: 25%;
		max-height: 70px;
		padding: 0;
	}

	.p-desc-box {
		background: var(--white);
		padding: 20px 15px;
		height: calc(100% - 200px);
	}
	.image-box {
		background: #f9f9f9;
		height: 200px;
		width: 100%;
		overflow: hidden;
		position: relative;

		.image {
			background-size: cover !important;
			background-position: center !important;
			width: 100%;
			height: 100%;
			transition: all 1s;
		}
	}
	.price-box {
		.price {
			font-size: 17px;
			font-family: var(--font-bold);

			.currency {
				text-transform: lowercase;
				text-transform: capitalize;
			}
			.point {
				font-size: 11px;
			}
		}
		.duration {
			margin: -4px 0 0 0;
			font-weight: 600;
			color: @grey;
			font-size: 12px;
		}
	}
	.name-box {
		.insurance {
			font-size: 17px;
			color: var(--text-color);
			font-family: var(--font-bold);
		}
		.txt {
			font-weight: 600;
			color: @grey;
			font-size: 14px;
		}
		.categories {
			margin: 0 0 7px 0;
		}
		.category:last-child {
			.circle {
				display: none;
			}
		}
		.name {
			font-weight: 600;
			color: @grey;
			font-size: 12px;
		}
		.circle {
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background: @grey;
			margin: 11px 10px 0 10px;
		}
	}
}
.ad-image:hover {
	.image {
		transform: scale(1.2);
	}
}
</style>
